var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slide-y-up-transition',{attrs:{"duration":400+(_vm.index*100),"delay":200+(_vm.index*100)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"box-info",domProps:{"innerHTML":_vm._s(_vm.item)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }